import { ChevronRight, Delete, Edit } from '@mui/icons-material'
import { Box, Chip, IconButton } from '@mui/material'
import { INFO_COLORS } from 'asterX-UI'
import { ACCOUNTANT } from 'lib/constants/roles'
import { formatTime, getAge, getFullName, getValidDate } from 'lib/utils'
import QrIcon from '../../asterX-UI/Icons/QR_Icon'

const getTypeName = data => {
  switch (data?.type) {
    case 'CLIENT':
      return 'Гарантия физ лиц'
    case 'LEGAL_CLIENT':
      return 'Гарантия юр лиц'
    case 'CAR':
      return getFullName(data?.brand, data?.model, data?.yearOfManufacture)
    case 'REAL_ESTATE':
      return 'Под залог недвижимости'
    default:
      return '-'
  }
}
export const getTableDataByRoleAndTab = (role, data ) => {
  const onOpenModal = data?.onOpenModal || null;
  const tableData = {
    MANAGER: {
      applications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            [null, 'userCreateLoanApplication', 'userCreateClientOTP'].includes(item?.status?.code) ? (
              <Chip
                size="small"
                label={'Продолжить заполнение'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            ) : (
              <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
                {item?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
              </Box>
            ),
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      clients: {
        columns: ['Клиент', 'Пол', 'Заявка', 'Дата рождения', 'Мобильный телефон', 'Менеджер', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(item?.lastName, item?.firstName, item?.patronymic)}
            </Box>,
            item?.sexName?.name || '-',
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.applicationCode || '-'}</Box>,
            `${getValidDate(item?.birthDate)} ${getAge(item?.birthDate)}`,
            item?.mobilePhone1?.toPhone() || '-',
            'SP0201',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      contracts: {
        columns: ['№', 'Клиент', 'Номер контракта', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplication?.clientFullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.bsContractName || '-'}</Box>,
            item?.loanApplication?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item?.loanApplication?.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.loanApplication?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={
                  item?.loanApplication?.status?.name || item?.loanApplication?.status?.code || 'Заявка авторизована'
                }
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      collaterals: {
        columns: ['Наименование', 'Залогодатель', 'Контракт', 'Заявка', 'Залоговая стоимость', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{getTypeName(item)}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(
                item?.clientGuarantee?.firstName,
                item?.clientGuarantee?.lastName,
                item?.clientGuarantee?.patronymic
              )}
            </Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.contractId || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplicationId}</Box>,
            item?.collateralValue?.toString().thousandSeparator() || '-',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      }
    },

    UNDERWRITER: {
      main: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            <Chip
              size="small"
              label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
              variant="outlined"
              sx={{ borderRadius: '6px', fontSize: '12px' }}
            />,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      applications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      clients: {
        columns: ['Клиент', 'Пол', 'Заявка', 'Дата рождения', 'Мобильный телефон', 'Менеджер', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(item?.lastName, item?.firstName, item?.patronymic)}
            </Box>,
            item?.sexName?.name || '-',
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.applicationCode || '-'}</Box>,
            `${getValidDate(item?.birthDate)} ${getAge(item?.birthDate)}`,
            item?.mobilePhone1?.toPhone() || '-',
            'SP0201',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      contracts: {
        columns: ['№', 'Клиент', 'Номер контракта', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplication?.clientFullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.bsContractName || '-'}</Box>,
            item?.loanApplication?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item?.loanApplication?.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.loanApplication?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={
                  item?.loanApplication?.status?.name || item?.loanApplication?.status?.code || 'Заявка авторизована'
                }
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      collaterals: {
        columns: ['Наименование', 'Залогодатель', 'Контракт', 'Заявка', 'Залоговая стоимость', ''],

        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{getTypeName(item)}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(
                item?.clientGuarantee?.firstName,
                item?.clientGuarantee?.lastName,
                item?.clientGuarantee?.patronymic
              )}
            </Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.contractId || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplicationId}</Box>,
            item?.collateralValue?.toString().thousandSeparator() || '-',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      ownApplications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      }
    },

    HEAD_UNDERWRITER: {
      main: {
        columns: ['Андеррайтер', 'В работе', 'Среднее время', 'Уровень одобрения', 'Заявок рассмотренно'],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.fullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.inProgressAppId || '-'}</Box>,
            formatTime(item?.averageTime) || '-',
            item?.approveCount?.toString() || '-',
            item?.done?.toString() || '-'
          ]
        })
      },
      applications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      clients: {
        columns: ['Клиент', 'Пол', 'Заявка', 'Дата рождения', 'Мобильный телефон', 'Менеджер', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(item?.lastName, item?.firstName, item?.patronymic)}
            </Box>,
            item?.sexName?.name || '-',
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.applicationCode || '-'}</Box>,
            `${getValidDate(item?.birthDate)} ${getAge(item?.birthDate)}`,
            item?.mobilePhone1?.toPhone() || '-',
            'SP0201',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      contracts: {
        columns: ['№', 'Клиент', 'Номер контракта', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplication?.clientFullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.bsContractName || '-'}</Box>,
            item?.loanApplication?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item?.loanApplication?.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.loanApplication?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={
                  item?.loanApplication?.status?.name || item?.loanApplication?.status?.code || 'Заявка авторизована'
                }
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      collaterals: {
        columns: ['Наименование', 'Залогодатель', 'Контракт', 'Заявка', 'Залоговая стоимость', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{getTypeName(item)}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(
                item?.clientGuarantee?.firstName,
                item?.clientGuarantee?.lastName,
                item?.clientGuarantee?.patronymic
              )}
            </Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.contractId || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplicationId}</Box>,
            item?.collateralValue?.toString().thousandSeparator() || '-',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      ownApplications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      }
    },

    SUPER_UNDERWRITER: {
      main: {
        columns: ['Андеррайтер', 'В работе', 'Среднее время', 'Уровень одобрения', 'Заявок рассмотренно'],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.fullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.inProgressAppId || '-'}</Box>,
            formatTime(item?.averageTime) || '-',
            item?.approveCount?.toString() || '-',
            item?.done?.toString() || '-'
          ]
        })
      },
      applications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      clients: {
        columns: ['Клиент', 'Пол', 'Заявка', 'Дата рождения', 'Мобильный телефон', 'Менеджер', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(item?.lastName, item?.firstName, item?.patronymic)}
            </Box>,
            item?.sexName?.name || '-',
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.applicationCode || '-'}</Box>,
            `${getValidDate(item?.birthDate)} ${getAge(item?.birthDate)}`,
            item?.mobilePhone1?.toPhone() || '-',
            'SP0201',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      contracts: {
        columns: ['№', 'Клиент', 'Номер контракта', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplication?.clientFullName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.bsContractName || '-'}</Box>,
            item?.loanApplication?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item?.loanApplication?.createdDate, true),
            <Box sx={{gap:"5px",display:'flex',alignItems:'center'}}>
              {item?.loanApplication?.isSignedOnline && <QrIcon size={16}></QrIcon>}
              <Chip
                size="small"
                label={
                  item?.loanApplication?.status?.name || item?.loanApplication?.status?.code || 'Заявка авторизована'
                }
                variant="outlined"
                sx={{ borderRadius: '6px', fontSize: '12px' }}
              />
            </Box>,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      collaterals: {
        columns: ['Наименование', 'Залогодатель', 'Контракт', 'Заявка', 'Залоговая стоимость', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{getTypeName(item)}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>
              {getFullName(
                item?.clientGuarantee?.firstName,
                item?.clientGuarantee?.lastName,
                item?.clientGuarantee?.patronymic
              )}
            </Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.contractId || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplicationId}</Box>,
            item?.collateralValue?.toString().thousandSeparator() || '-',
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      },
      ownApplications: {
        columns: ['№', 'Клиент', 'Продукт', 'Сумма займа', 'Дата создания', 'Статус', ''],
        rows: data.listData.map(item => {
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.clientFullName || '-'}</Box>,
            item?.creditProduct?.name || '-',
            item?.loanAmount?.toString()?.thousandSeparator() || '-',
            getValidDate(item.createdDate, true),
            <Chip
              size="small"
              label={item?.status?.name || item?.status?.code || 'Заявка авторизована'}
              variant="outlined"
              sx={{ borderRadius: '6px', fontSize: '12px' }}
            />,
            {
              isButton: true,
              label: <ChevronRight />,
              id: item?.id
            }
          ]
        })
      }
    },
    DICT_ADMIN: {
      groups: {
        columns: ['ID', 'Название', 'Код', ''],
        rows: (data.listData ?? []).map(item => {
          const rowId = item.id
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item.id}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item.name}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item.code}</Box>,
            {
              label: (
                <Box display="flex" gap={1}>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('edit', 'groups', item) }}>
                    <Edit />
                  </IconButton>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('delete', 'groups', item) }}>
                    <Delete />
                  </IconButton>
                </Box>
              ),
              isButton: true,
              id: rowId
            }
          ]
        })
      },
      dealers: {
        columns: ['ID', 'Название', 'Код', 'Город', 'Группа', ''],
        rows: (data.listData ?? []).map(item => {
          const rowId = item.id
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.id}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.name}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.code}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.cityName || '-'}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item?.dealerGroupCode || '-'}</Box>,
            {
              label: (
                <Box display="flex" gap={1}>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('edit', 'dealers', item) }}>
                    <Edit />
                  </IconButton>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('delete', 'dealers', item) }}>
                    <Delete />
                  </IconButton>
                </Box>
              ),
              isButton: true,
              id: rowId
            }
          ]
        })
      },
      locations: {
        columns: ['ID', 'Название', ''],
        rows: (data.listData ?? []).map(item => {
          const rowId = item.id
          return [
            <Box sx={{ color: INFO_COLORS[700] }}>{item.id}</Box>,
            <Box sx={{ color: INFO_COLORS[700] }}>{item.name}</Box>,
            {
              label: (
                <Box display="flex" gap={1}>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('edit', 'locations', item) }}>
                    <Edit />
                  </IconButton>
                  <IconButton size="small" onClick={e => { e.stopPropagation();
                    onOpenModal?.('delete', 'locations', item) }}>
                    <Delete />
                  </IconButton>
                </Box>
              ),
              isButton: true,
              id: rowId
            }
          ]
        })
      }
    },
    ACCOUNTANT: {
      columns: ['№', 'Клиент', 'Номер контракта', 'Сумма займа', 'Дата создания',"Дата выдачи", 'Статус', ''],
      rows: data.listData.map(item => {
        return [
          <Box sx={{ color: INFO_COLORS[700] }}>{item?.id || '-'}</Box>,
          <Box sx={{ color: INFO_COLORS[700] }}>{item?.loanApplication?.clientFullName || '-'}</Box>,
          <Box sx={{ color: INFO_COLORS[700] }}>{item?.bsContractName || '-'}</Box>,
          item?.loanApplication?.loanAmount?.toString()?.thousandSeparator() || '-',
          getValidDate(item?.loanApplication?.createdDate, true),
          item?.issuePlanDate || '-',
          <Chip
            size="small"
            label={item?.loanApplication?.status?.name || item?.loanApplication?.status?.code || 'Заявка авторизована'}
            variant="outlined"
            sx={{ borderRadius: '6px', fontSize: '12px' }}
          />,
          {
            isButton: true,
            label: <ChevronRight />,
            id: item?.id
          }
        ]
      })
    }
  }

  if (role === ACCOUNTANT) {
    return tableData.ACCOUNTANT
  }

  return tableData[role]?.[data.tab] || { columns: [], rows: [] }
}
